import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Бизнес-отказы правки блоков (§6.1). Приходят как `422` с объектным detail,
 * то есть в ветку `business` — ветвление по `code` не трогает
 * `never`-исчерпывность `failureText` по `kind`.
 *
 * Потолок блоков за прогон ВРЕМЕННЫЙ (снижен с 200 до первого боевого
 * прогона), поэтому число берём из серверного `message`, а не из своей
 * константы: зашитое устареет молча и соврёт автору.
 */
export const blockEditFailureText = (code: string, message: string): string | null => {
  switch (code) {
    case 'too_many_blocks':
      return messagesNow(messages).tooManyBlocks(message)
    case 'unknown_blocks':
      // Первые пять id перечисляет сам бэк — показываем как есть.
      return messagesNow(messages).unknownBlocks(message)
    default:
      return null
  }
}
